import type { AppSession, LineRequest } from "../api/types";
import { readJson, remove, writeJson } from "../lib/storage";

/**
 * What the Tafo app keeps on the device (ADR 0011): its own device token (a till and the app can run in
 * one browser), who is signed in (12 hours), and what the waiter put on a table but did not send to the
 * kitchen yet ("Nieuw (nog niet verstuurd)"). Nothing else: orders always come from the server.
 */
const DEVICE_KEY = "tafo.app.deviceToken";
const SESSION_KEY = "tafo.app.session";
const DRAFTS_KEY = "tafo.app.drafts";
/** Unconfirmed sales and payments of the app (see api/pending), apart from the till's. */
export const APP_PENDING_KEY = "tafo.app.pending";

export const appDevice = {
  read: (): string | null => readJson<string | null>(DEVICE_KEY, null),
  save: (token: string): void => {
    writeJson(DEVICE_KEY, token);
  },
  clear: (): void => {
    remove(DEVICE_KEY);
    remove(SESSION_KEY);
  },
};

export const appSession = {
  read: (): AppSession | null => readJson<AppSession | null>(SESSION_KEY, null),
  save: (session: AppSession): void => {
    writeJson(SESSION_KEY, session);
  },
  clear: (): void => {
    remove(SESSION_KEY);
  },
};

/** A line put on a table or a takeaway in the app, not sent to the kitchen yet. */
export interface DraftLine extends LineRequest {
  /** Stable identity on screen; never sent to the server. */
  key: string;
}

/**
 * Per table ("t:7") or the takeaway ("afhaal"): the lines not sent yet and, for a takeaway, the customer: name,
 * phone, e-mail and the note on the receipt (Furkan, 19/10/2026; a draft kept before has the name only).
 */
export interface Draft {
  lines: DraftLine[];
  name: string;
  phone?: string;
  email?: string;
  note?: string;
}

export type Drafts = Record<string, Draft>;

export const appDrafts = {
  read: (): Drafts => readJson<Drafts>(DRAFTS_KEY, {}),
  save: (drafts: Drafts): void => {
    writeJson(DRAFTS_KEY, drafts);
  },
};
